import { useAppDispatch, useAppSelector } from '@/hooks';
import { useGetContactSupportQuery } from '@/store/api/userApi';
import { setAgeModalOpen } from '@/store/slices/uiSlice';
import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const dispatch = useAppDispatch();
  const { supportInfo } = useAppSelector((state) => state.user);
  useGetContactSupportQuery();
  return (
    <footer className="mt-1">
      <div className="w-full bg-footer-bg text-body-inverse text-xs px-2 py-1">
        <div className="grid md:grid-cols-3">
          {/* Left */}
          <div className="flex font-bold text-xs md:text-base text-center max-md:justify-between items-center">
            <Link
              target="_blank"
              rel="noopener noreferrer"
              to="/terms-and-conditions"
              className="cursor-pointer max-md:underline p-2"
            >
              Terms and Conditions
            </Link>
            <Link
              target="_blank"
              rel="noopener noreferrer"
              to="/responsible-gaming"
              className="cursor-pointer max-md:underline p-2"
            >
              Responsible Gaming
            </Link>
          </div>
          {/* Center */}
          <div className="text-2xl font-bold text-center flex items-center justify-center">
            <span>24X7 Support</span>
          </div>
          <div className="flex items-center justify-center md:justify-end gap-1">
            <a
              target="_blank"
              href={supportInfo?.telegram ?? '#'}
              className="size-10 bg-surface rounded-[15px] p-[5px]"
            >
              <img src="/icons/telegram.png" alt="" />
            </a>
            <a
              target="_blank"
              href={supportInfo?.whatsapp ?? '#'}
              className="size-10 bg-surface rounded-[15px] p-[5px]"
            >
              <img src="/icons/whatsapp.png" className="rounded-[15px]" alt="" />
            </a>
          </div>
        </div>
      </div>
      <div className="py-1 px-2 text-xs md:text-base">
        <div className="flex max-md:flex-col items-center justify-between gap-[10px]">
          <div className="flex items-center gap-2">
            <img src="/images/secure.png" alt="" />
            <div>
              <p className="font-bold">100% SAFE</p>
              <p>Protected connection and encrypted data.</p>
            </div>
          </div>
          <div className="flex gap-[10px]">
            <img
              onClick={() => dispatch(setAgeModalOpen(true))}
              className="size-[30px] cursor-pointer"
              src="/images/18plus.png"
              alt=""
            />
            <a href="https://www.gamcare.org.uk/" target="_blank" rel="noopener noreferrer">
              <img className="size-[30px]" src="/images/gamecare.png" alt="GamCare" />
            </a>

            <a href="https://www.gamblingtherapy.org/" target="_blank" rel="noopener noreferrer">
              <img className="size-[30px]" src="/images/gt.png" alt="Gambling Therapy" />
            </a>
          </div>
        </div>
        <p className="text-center mt-[10px]">
          © Copyright 2025. All Rights Reserved. Powered by shiv247.com
        </p>
      </div>
    </footer>
  );
};

export default Footer;
